import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "../lib/api";
import Navigation from "../components/landing/Navigation";
import Hero from "../components/landing/Hero";
import About from "../components/landing/About";
import Conditions from "../components/landing/Conditions";
import Models from "../components/landing/Models";
import ModelDetail from "../components/landing/ModelDetail";
import Consultants from "../components/landing/Consultants";
import LeadForm from "../components/landing/LeadForm";
import StickyCTA from "../components/landing/StickyCTA";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  const [models, setModels] = useState([]);
  const [consultants, setConsultants] = useState([]);
  const [detailModel, setDetailModel] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    api.get("/models").then((r) => setModels(r.data)).catch(() => {});
    api.get("/consultants").then((r) => setConsultants(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-white">
      <Navigation />
      <Hero />
      <About />
      <Conditions />
      <Models models={models} onShowDetail={setDetailModel} />
      <Consultants consultants={consultants} />
      <LeadForm models={models} />
      <Footer />
      <StickyCTA />
      <ModelDetail model={detailModel} onClose={() => setDetailModel(null)} />
    </div>
  );
}
